import { copyTrackItem } from '@com/components/timeline-panel/utils/track-action'
import { getConflictSegment } from '@com/components/timeline-panel/utils/track-insert-position'
import { IvTrackType } from '@ps/store/interactive-video/timeline/enums'
import {
  getTimelineBySceneUuid,
  setTimeline,
} from '@ps/store/interactive-video/timeline/timeline'
import { IvSegment, IvTrack } from '@ps/store/interactive-video/timeline/types'
import {
  getIvRelativedSegments,
  getSceneSegments,
  isIvSegment,
  isSegmentIv,
  isSegmentVideo,
} from '@ps/store/interactive-video/timeline/utiles'
import { updateByVideoSegment } from '@ps/store/interactive-video/timeline/utiles/segment'
import {
  addIvSegment,
  insertBeforeIvTrack,
  removeIvSegment,
} from '@ps/store/interactive-video/timeline/utiles/track-action'

export function cutTargetToScene(segment: IvSegment, data: IvTrack[]): void {
  const tracks = getTimelineBySceneUuid(segment.sceneUuid)
  const videoTrack = data.find((t) => t.type === IvTrackType.Video)
  if (!videoTrack) return
  const sortedVideoSegments = videoTrack.segments.sort(
    (a, b) => a.start - b.start,
  )
  const targetVideoSegmentIndex = sortedVideoSegments.findIndex(
    (s) => s.sceneUuid === segment.sceneUuid,
  )
  if (targetVideoSegmentIndex === -1) return
  const prevVideoSegments = sortedVideoSegments.slice(
    0,
    targetVideoSegmentIndex,
  )

  const sceneStart = prevVideoSegments.reduce((start, s) => start + s.frames, 0)
  // - realStart +
  const realStart = segment.start - sceneStart
  cutTarget({ ...segment, start: realStart }, tracks)

  setTimeline(segment.sceneUuid, tracks)
}

export function cutTarget(segment: IvSegment, tracks: IvTrack[]): void {
  const sceneSegments = getSceneSegments(segment.sceneUuid, tracks)

  const target = sceneSegments.find((s) => s.id === segment.id)
  if (!target) {
    return
  }

  let relativedSegments: ReturnType<typeof getIvRelativedSegments> = []

  if (isIvSegment(target) && isSegmentIv(target)) {
    relativedSegments = getIvRelativedSegments(target, tracks)
    console.log('aaa cutTarget relativedSegments', relativedSegments)
  }

  target.start = segment.start
  target.frames = segment.frames
  target.trimStart = segment.trimStart

  if (isSegmentIv(target)) {
    relativedSegments.forEach((s) => {
      s.start = target.start
      s.frames = target.frames
      const track = tracks.find((t) => t.id === s.trackId)
      if (track && getConflictSegment(s, track)) {
        removeIvSegment(s, tracks, {
          removeTrackIfEmpty: false,
        })
        const newTrack = copyTrackItem(track)
        addIvSegment(s, newTrack as any)
        insertBeforeIvTrack(newTrack, track, tracks)
      }
    })
  } else if (isSegmentVideo(target)) {
    updateByVideoSegment(target.sceneUuid, tracks)

    if (target.start !== 0) {
      const reverseStart = -target.start
      sceneSegments.forEach((s) => {
        s.start += reverseStart
      })
    }
  }
}
